import React, { useRef } from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import emailjs from '@emailjs/browser';
import Header from "../components/Header";
import Footer from '../components/Footer';


export default function Contact() {
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_hae9ma8', 'template_dj0ljpd', form.current, {
        publicKey: 'IPWrsuItLngAcT77K',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          alert('Message sent successfully!');
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Failed to send message. Please try again.');
        }
      );
  };

  return (
    <div style={{  minHeight: '100vh' }}>
      <Header />

      <Box
        sx={{
          px: { xs: 1, sm: 4 },
          py: { xs: 3, sm: 6 },
          backgroundColor: 'transparent',
          minHeight: '100vh',
        }}
      >
        <Paper
          elevation={6}
          sx={{
            maxWidth: 950,
            mx: 'auto',
            p: { xs: 2, sm: 5 },
            borderRadius: 4,
            boxShadow: '0 8px 32px 0 rgba(74,156,159,0.15)',
            background: 'rgba(255,255,255,0.95)',
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            textAlign="center"
            sx={{
              color: '#357376',
              letterSpacing: 1,
              mb: 1,
            }}
          >
            Contact Us
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            textAlign="center"
            sx={{ color: '#555', mb: 3 }}
          >
            We'd love to hear from you! Whether you have a question about our programs, want to get involved, or just
            want to say hello.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 5,
              mt: 1,
            }}
          >
            {/* Contact Form Card */}
            <Box sx={{ flex: 1 }}>
              <Paper
                elevation={3}
                sx={{
                  p: { xs: 2, sm: 3 },
                  borderRadius: 3,
                  height: '100%',
                  background: 'rgba(247,250,253,0.95)',
                }}
              >
                <form ref={form} onSubmit={handleSubmit}>
                  <TextField
                    label="Full Name"
                    name="fullName"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    required
                    InputProps={{
                      sx: { borderRadius: 2, background: '#f7fafd' },
                    }}
                  />
                  <TextField
                    label="Email Address"
                    name="email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    required
                    InputProps={{
                      sx: { borderRadius: 2, background: '#f7fafd' },
                    }}
                  />
                  <TextField
                    label="Phone Number"
                    name="phone"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    InputProps={{
                      sx: { borderRadius: 2, background: '#f7fafd' },
                    }}
                  />
                  <TextField
                    label="Message"
                    name="message"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    multiline
                    rows={5}
                    required
                    InputProps={{
                      sx: { borderRadius: 2, background: '#f7fafd' },
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      mt: 3,
                      background: 'linear-gradient(90deg, #4a9c9f 60%, #357376 100%)',
                      color: '#fff',
                      fontWeight: 'bold',
                      borderRadius: 2,
                      boxShadow: '0 2px 8px 0 rgba(74,156,159,0.15)',
                      letterSpacing: 1,
                      '&:hover': {
                        background: 'linear-gradient(90deg, #357376 60%, #4a9c9f 100%)',
                      },
                    }}
                    fullWidth
                  >
                    Send Message
                  </Button>
                </form>
              </Paper>
            </Box>

            {/* Contact Info Card */}
            <Box sx={{ flex: 1 }}>
              <Paper
                elevation={3}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  gap: 5,
                  p: { xs: 2, sm: 4 },
                  height: '100%',
                  borderRadius: 3,
                  background: 'linear-gradient(120deg, #fffde4 60%, #e0f7fa 100%)',
                  boxShadow: '0 2px 12px 0 rgba(74,156,159,0.10)',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: '#357376' }}>
                    Head Office
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    Samriddhi Trust<br />
                    48-B, Vivek Vihar, New Sanganer Road<br />
                    Jaipur, Rajasthan 302019<br />
                    India
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: '#357376' }}>
                    Contact Info
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    Email: <a href="mailto:adesh@samriddhitrust.in" style={{ color: '#4a9c9f', textDecoration: 'none', fontWeight: 500 }}>adesh@samriddhitrust.in</a><br />
                    Phone: <a href="tel:+917774906146" style={{ color: '#4a9c9f', textDecoration: 'none', fontWeight: 500 }}>+91 77749 06146</a>
                  </Typography>
                </Box>
              </Paper>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Footer />
    </div>
  );
}
